// Shared `slotProps` for MUI TextField `select` dropdowns inside `maxWidth="sm"`
// dialogs. Caps the menu paper so long item text truncates instead of
// overflowing the dialog. Width tracks the `sm` breakpoint minus DialogContent's
// horizontal padding (24px × 2); the viewport `calc` keeps it from bleeding
// off-screen on narrow devices. MUI's default `min-width: anchor` still keeps
// the menu at least as wide as the trigger.
export const DROPDOWN_SLOT_PROPS = {
  select: {
    MenuProps: {
      PaperProps: {
        sx: (theme) => ({
          maxWidth: `min(${theme.breakpoints.values.sm - 48}px, calc(100vw - 32px))`,
        }),
      },
    },
  },
};
